import { MatLegacyTable as MatTable } from '@angular/material/legacy-table';
import { NgZone } from '@angular/core';
import { take } from 'rxjs/operators';

// Workaround für die Neuberechnung der Material Table Sticky Styles
export const updateStickyColumnStyles = (table: MatTable<any>, ngZone: NgZone): void => {
  ngZone.onMicrotaskEmpty.pipe(take(3)).subscribe(() => {
    table.updateStickyHeaderRowStyles();
    table.updateStickyColumnStyles();
  });
};
